var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-flat-item',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"primary",attrs:{"small":""},on:{"click":_vm.showTextEditorModal}},[_vm._v(" "+_vm._s(_vm.$t('common.show'))+"/"+_vm._s(_vm.$t('common.edit'))+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }